import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=17f756cc&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrackingNoscript: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/_trackingNoscript.vue').default,HomepageHeader: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageHeader.vue').default,PageFooter: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/page/PageFooter.vue').default})
